import { IDiscordMessageGroup } from "#api/discord";
import { Timestamp } from "#components/dates";
import { Message } from "./message";

import * as styles from "./styles.module.scss";

interface IProps {
  group: IDiscordMessageGroup;
}

export function MessageGroup({ group }: IProps) {
  return (
    <div className={styles.messageGroupContainer} key={`${group.author.id}-${group.messages[0].id}`}>
      <img
        className={styles.userAvatar}
        src={`https://cdn.discordapp.com/avatars/${group.author.id}/${group.author.avatar}`}
        alt={`${group.author.username}'s avatar`}
        onError={e => e.target && ((e.target as HTMLImageElement).src = "/static/discordgrey.png")}
      />
      <div className={styles.messageGroupContent}>
        <header>
          <strong className={styles.username} title={group.author.username}>{group.author.username}</strong> {/* TODO: use global_name when added to API */}
          <Timestamp time={group.messages[0].published} showHour />
        </header>
        <ul>
          {group.messages.map(message => <Message message={message} />)}
        </ul>
      </div>
    </div>
  )
}
